export const styles = {
  filterListTitle: { fontSize: "14px", fontWeight: "bold", color: "#444" },
  filterList: { bgcolor: "background.paper", padding: "0px", marginTop: "4px" },
  filterListItem: {
    border: "solid 1px #ddd",
    borderRadius: "3px",
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingTop: 0,
    fontSize: "12px",
    marginBottom: "10px",
    backgroundColor: "#f9f9f9",
  },
  filterListItemText: {
    marginTop: "0px",
    marginBottom: "0px",
    paddingTop: "4px",
    paddingBottom: "4px",
    "& *": {
      fontSize: "0.85rem!important",
    },
  },
  sidebarForGalleryPhotographDesktop: {
    zIndex: 99,
    width: 260,
    height: "100vh",
    float: "left",
    display: "block",
    overflow: "hidden",
    position: "sticky",
    background: "#f4f4f4",
    marginTop: "8px",
    padding: "0px 0px 15px 30px",
  },
  sidebarForGalleryPhotographDesktopSpacer: {
    left: -34,
    height: 25,
    bottom: 25,
    width: "120%",
    background: "#fff",
    position: "relative",
  },
  sidebarForGalleryPhotographDesktopHeading: {
    fontSize: 16,
    fontWeight: 600,
  },
  accordion: {
    overflow: "auto",
  },
  accordianHeading: {
    margin: 0,
    fontSize: 16,
    width: "150px",
  },
};
